<template>
  <div class="page" :class="{'is-mobile' : $vuetify.breakpoint.mobile}">
    <div class="content">
      <v-container fluid>
        <DetalheFornecedorDialog :item="item" v-model="detalheDialogOpened"/>
        <v-row>
          <v-col cols="12" sm="4">
            <span class="titulo">Olá, {{userName}},</span>
            <br/>
            <span class="sub-titulo">Como você está se sentindo hoje?</span>
          </v-col>
        </v-row>
        <!-- Inicio filtro -->
        <v-row>
          <v-col cols="12">
            <v-card class="mb-4" outlined>
              <v-card-title class="d-flex justify-space-between align-center">
                <span class="titulo">Filtros</span>
                <div>
                  <v-btn icon @click="showFilters = !showFilters" :title="showFilters ? 'Esconder filtros' : 'Exibir filtros'">
                    <v-icon>{{ showFilters ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  </v-btn>
                  <v-btn color="primary" outlined class="ml-2" @click="clearFilters" title="Limpar filtros">
                    <v-icon left>mdi-filter-remove</v-icon> Limpar
                  </v-btn>
                </div>
              </v-card-title>
              <v-expand-transition>
                <v-card-text class="py-4 flex-grow-1" 
                  v-show="showFilters">
                  <v-row>
                    <v-col cols="12" sm="4">
                      <search-box
                          label="CNPJ"
                          popup-label="Selecione um CNPJ"
                          :chave.sync="localSearch.cnpjAux.chave"
                          :valor.sync="localSearch.cnpjAux.valor"
                          :hidden-clear="false"
                          :value="cnpj"
                          :loader-fn="loadCnpj"
                          item-key="chave"
                          item-text="valor">
                        <template v-slot:empty>
                          <p class="ma-2">
                            Nenhum CNPJ encontrado
                          </p>
                        </template>
                      </search-box>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <lookup-dominio label="Estado"
                                      :hidden-clear="false"
                                      v-model="localSearch.estadoAux"
                                      :type="lookups.estado"/>
                    </v-col>  
                    <v-col cols="12" sm="4">
                      <search-box ref="comboCidades"
                          label="Cidades"
                          popup-label="Selecione uma Cidade"
                          :chave.sync="localSearch.cidadeAux.chave"
                          :valor.sync="localSearch.cidadeAux.valor"
                          :hidden-clear="false"
                          :value="cidade"
                          :loader-fn="loadCidades"
                          item-key="chave"
                          item-text="valor">
                        <template v-slot:empty>
                          <p class="ma-2">
                            Nenhuma Cidade encontrada
                          </p>
                        </template>
                      </search-box>
                    </v-col>
                    <v-col cols="12" md="4">
                      <search-box ref="comboSetor"
                          label="Setor"
                          popup-label="Selecione um Setor"
                          :id.sync="localSearch.setor.id"
                          :descricao.sync="localSearch.setor.descricao"
                          :hidden-clear="false"
                          :value="setor"
                          :loader-fn="loadSetor"
                          item-key="id"
                          item-text="descricao">
                        <template v-slot:empty>
                          <p class="ma-2">
                            Nenhum Setor encontrado
                          </p>
                        </template>
                      </search-box>
                    </v-col>
                    <v-col cols="12" md="4">
                      <search-box ref="comboPorte"
                          label="Porte"
                          popup-label="Selecione um Porte"
                          :id.sync="localSearch.porte.id"
                          :descricao.sync="localSearch.porte.descricao"
                          :hidden-clear="false"
                          :value="porte"
                          :loader-fn="loadPorte"
                          item-key="id"
                          item-text="descricao">
                        <template v-slot:empty>
                          <p class="ma-2">
                            Nenhum Porte encontrado
                          </p>
                        </template>
                      </search-box>
                    </v-col>
                    <v-col cols="12" md="4">
                      <search-box ref="comboRamoAtuacao"
                          label="Ramo de Atuação"
                          popup-label="Selecione um Ramo de Atuação"
                          :id.sync="localSearch.ramoAtuacao.id"
                          :descricao.sync="localSearch.ramoAtuacao.descricao"
                          :hidden-clear="false"
                          :value="ramoAtuacao"
                          :loader-fn="loadRamoAtuacao"
                          item-key="id"
                          item-text="descricao">
                        <template v-slot:empty>
                          <p class="ma-2">
                            Nenhum Ramo de Atuação encontrado
                          </p>
                        </template>
                      </search-box>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-expand-transition>
            </v-card>
          </v-col>
        </v-row>
        <!-- Fim filtro -->
        <v-row>         
          <v-col cols="12" sm="4">
            <PainelCard :title="totalFornecedorPorSetor.tituloGrafico" corTitulo="#188BC6" corFundo="#FFFFFF"
              :loading="totalFornecedorPorSetor.isLoading" :minHeight="250" icon="mdi-briefcase-arrow-left-right">
              <apexchart ref="totalFornecedorPorSetor"
                type="donut"
                :height="200"
                :options="totalFornecedorPorSetor.chartOptions"
                :series="totalFornecedorPorSetor.series"
              />
            </PainelCard>
          </v-col>
          <v-col cols="12" sm="4">
            <PainelCard :title="totalFornecedorPorPorte.tituloGrafico" corTitulo="#188BC6" corFundo="#FFFFFF"
              :loading="totalFornecedorPorPorte.isLoading" :minHeight="250" icon="mdi-package-up">
              <apexchart ref="totalFornecedorPorPorte"
                type="donut"
                :height="200"
                :options="totalFornecedorPorPorte.chartOptions"
                :series="totalFornecedorPorPorte.series"
              />
            </PainelCard>
          </v-col>
          <v-col cols="12" sm="4">
            <PainelCard :title="totalFornecedorPorRamoAtuacao.tituloGrafico" corTitulo="#188BC6" corFundo="#FFFFFF"
              :loading="totalFornecedorPorRamoAtuacao.isLoading" :minHeight="250" icon="mdi-layers">
              <apexchart ref="totalFornecedorPorRamoAtuacao"
                type="donut"
                :height="200"
                :options="totalFornecedorPorRamoAtuacao.chartOptions"
                :series="totalFornecedorPorRamoAtuacao.series"
              />
            </PainelCard>
          </v-col>
          <v-col cols="12" sm="4">
            <PainelCard :title="totalFornecedorPorEstado.tituloGrafico" corTitulo="#188BC6" corFundo="#FFFFFF"
              :loading="totalFornecedorPorEstado.isLoading" :minHeight="250" icon="mdi-map-legend">
              <apexchart ref="totalFornecedorPorEstado"
                type="bar"
                :height="200"
                :options="totalFornecedorPorEstado.chartOptions"
                :series="totalFornecedorPorEstado.series"
              />
            </PainelCard>
          </v-col>
          <v-col cols="12" sm="8">
            <PainelCard :title="totalFornecedorPorCidade.tituloGrafico" corTitulo="#188BC6" corFundo="#FFFFFF"
              :loading="totalFornecedorPorCidade.isLoading" :minHeight="250" icon="mdi-map-marker-outline">
              <apexchart ref="totalFornecedorPorCidade"
                type="bar"
                :height="200"
                :options="totalFornecedorPorCidade.chartOptions"
                :series="totalFornecedorPorCidade.series"
              />
            </PainelCard>
          </v-col>
          <v-col cols="12" sm="12">
            <PainelCard title="Lista de Fornecedores" corTitulo="#188BC6" corFundo="#FFFFFF"
              :loading="false" :minHeight="250" icon="mdi-list-box-outline">
              <FornecedorDataTable ref="dataTableFornecedor"
                @click:verDetalhe="verDetalhe"
                :view-actions="false"
                :search-values="searchValuesLista"/>
            </PainelCard>
          </v-col> 
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import {findGraficoFornecedor} from "../../api/painel";
import {ItemDeDominio} from "../../api/itemsDominio";
import LookupDominio from "../../components/shared/common/LookupDominio";
import FornecedorDataTable from "../../components/shared/datatables/FornecedorDataTable";
import DetalheFornecedorDialog from "../../components/shared/dialogs/DetalheFornecedorDialog";
import PainelCard from "./components/PainelCard";
import SearchBox from "../../components/shared/common/SearchBox";
import {mapActions, mapGetters} from "vuex";
import {ApiError} from "../../api/core";
//PKs
import {findOne as findOneFornecedor, listaCnpj, listaCidades} from "../../api/fornecedor";
import {findAll as findAllSetor} from "../../api/setor";
import {findAll as findAllPorte} from "../../api/porte";
import {findAll as findAllRamoAtuacao} from "../../api/ramoAtuacao";

export default {
  name: "Painel",
  components: {DetalheFornecedorDialog, FornecedorDataTable, PainelCard, SearchBox, LookupDominio},
  data() {
    return {
      localSearch: {
        cnpjAux: {
          chave: null,
          valor: null
        },
        estadoAux: null,
        cidadeAux: {
          chave: null,
          valor: null
        },
        setor: {
          id: null,
          descricao: null
        },
        porte: {
          id: null,
          descricao: null
        },
        ramoAtuacao: {
          id: null,
          descricao: null
        },
      },
      item: null,
      loading: false,
      searchValuesLista: {
        qtdRegPorPag: 20,
        cnpj: null,
        cidade: null,
        estado: null,
        idSetor: null,
        idPorte: null,
        idRamoAtuacao: null,
      },
      detalheDialogOpened: false,
      lookups: {
        estado: ItemDeDominio.COMBO_ESTADO, 
      },
      totalFornecedorPorSetor: {
        isLoading: false,
        tituloGrafico: "Fornecedores Por Setor",
        series: [],
        chartOptions: {
          chart: {
            type: 'donut',
            height: 420,
          },
          labels: [],
          dataLabels: {
            enabled: true,
            formatter: (val) => `${val.toFixed(1)}%`
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  total: {
                    show: true,
                    label: 'Total',
                    formatter: function (w) {
                      return w.globals.seriesTotals.reduce((a, b) => a + b, 0)
                    }
                  }
                }
              }
            }
          },
          legend: {
            position: 'bottom',
            horizontalAlign: 'center'
          },
          responsive: [{
            breakpoint: 400,
            options: {
              chart: {
                height: 300,
                position: 'left',
              },
            }
          }]          
        }
      },
      totalFornecedorPorPorte: {
        isLoading: false,
        tituloGrafico: "Fornecedores Por Porte",
        series: [],
        chartOptions: {
          chart: {
            type: 'donut',
            height: 420,
          },
          labels: [],
          dataLabels: {
            enabled: true,
            formatter: (val) => `${val.toFixed(1)}%`
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  total: {
                    show: true,
                    label: 'Total',
                    formatter: function (w) {
                      return w.globals.seriesTotals.reduce((a, b) => a + b, 0)
                    }
                  }
                }
              }
            }
          },
          legend: {
            position: 'bottom',
            horizontalAlign: 'center'
          },
          responsive: [{
            breakpoint: 400,
            options: {
              chart: {
                height: 300,
                position: 'left',
              },
            }
          }]          
        }
      },
      totalFornecedorPorRamoAtuacao: {
        isLoading: false,
        tituloGrafico: "Fornecedores Por Ramo de Atuação",
        series: [],
        chartOptions: {
          chart: {
            type: 'donut',
            height: 420,
          },
          labels: [],
          dataLabels: {
            enabled: true,
            formatter: (val) => `${val.toFixed(1)}%`
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  total: {
                    show: true,
                    label: 'Total',
                    formatter: function (w) {
                      return w.globals.seriesTotals.reduce((a, b) => a + b, 0)
                    }
                  }
                }
              }
            }
          },
          legend: {
            position: 'bottom',
            horizontalAlign: 'center'
          },
          responsive: [{
            breakpoint: 400,
            options: {
              chart: {
                height: 300,
                position: 'left',
              },
            }
          }]          
        }
      },
      totalFornecedorPorEstado: {
        isLoading: false,
        tituloGrafico: "Fornecedores Por Estado",
        series: [{
          name: 'Fornecedores',
          data: []
        }],
        chartOptions: {
          chart: {
            type: 'bar',
            height: 420,
          },
          xaxis: {
            categories: [],
            title: {
              text: 'Estado'
            }
          },
          dataLabels: {
            enabled: true
          },
          plotOptions: {
            bar: {
              borderRadius: 4,
              horizontal: false,
            }
          },
          legend: {
            position: 'bottom',
            horizontalAlign: 'center'
          },
          responsive: [{
            breakpoint: 400,
            options: {
              chart: {
                height: 300,
                position: 'left',
              },
            }
          }]          
        }
      },
      totalFornecedorPorCidade: {
        isLoading: false,
        tituloGrafico: "Fornecedores Por Cidade",
        series: [{
          name: 'Fornecedores',
          data: []
        }],
        chartOptions: {
          chart: {
            type: 'bar',
            height: 420,
          },
          xaxis: {
            categories: [],
            title: {
              text: 'Cidade'
            }
          },
          dataLabels: {
            enabled: false
          },
          plotOptions: {
            bar: {
              borderRadius: 4,
              horizontal: false,
            }
          },
          legend: {
            position: 'bottom',
            horizontalAlign: 'center'
          },
          responsive: [{
            breakpoint: 400,
            options: {
              chart: {
                height: 300,
                position: 'left',
              },
            }
          }]          
        }
      },
      showFilters: false,
    }
  },
  computed: {
    ...mapGetters('auth',['user','isAuthenticated', 'nivelUsuarioLogado']),
    userName: {
      get() {
        return this.user?.nome;
      }
    },
    cnpj(){
      if (this.localSearch.cnpjAux.chave == null) return null;
      return {
        chave: this.localSearch.cnpjAux.chave,
        valor: this.localSearch.cnpjAux.valor
      }      
    },
    cidade(){
      if (this.localSearch.cidadeAux.chave == null) return null;
      return {
        chave: this.localSearch.cidadeAux.chave,
        valor: this.localSearch.cidadeAux.valor
      }      
    },
    setor(){
      if (this.localSearch.setor.id == null) return null;
      return {
        id: this.localSearch.setor.id,
        descricao: this.localSearch.setor.descricao
      }      
    },
    porte(){
      if (this.localSearch.porte.id == null) return null;
      return {
        id: this.localSearch.porte.id,
        descricao: this.localSearch.porte.descricao
      }      
    },
    ramoAtuacao(){
      if (this.localSearch.ramoAtuacao.id == null) return null;
      return {
        id: this.localSearch.ramoAtuacao.id,
        descricao: this.localSearch.ramoAtuacao.descricao
      }      
    },    
  },
  watch: {
    'localSearch.estadoAux': {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$refs.comboCidades.resetValues();
          this.$refs.comboCidades.search();
          this.searchValuesLista.estado = newValue;
          this.refresh();
        }
      }
    },
    'localSearch.cnpjAux.chave': {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.searchValuesLista.cnpj = newValue;
          this.refresh();
        }
      }
    },
    'localSearch.cidadeAux.chave': {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.searchValuesLista.cidade = newValue;
          this.refresh();
        }
      }
    },
    'localSearch.setor.id': {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.searchValuesLista.idSetor = newValue;
          this.refresh();
        }
      }
    },
    'localSearch.porte.id': {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.searchValuesLista.idPorte = newValue;
          this.refresh();
        }
      }
    },
    'localSearch.ramoAtuacao.id': {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.searchValuesLista.idRamoAtuacao = newValue;
          this.refresh();
        }
      }
    },
  }, 
  methods: {
    ...mapActions('itemsDominio', ['fetch']),
    loadCnpj(page, search) {
      return listaCnpj(page, {});
    },
    loadCidades(page, search) {
      return listaCidades(page, {
        cidade: search,
        estado: this.localSearch.estadoAux,
      });
    },
    loadSetor(page, search) {
      return findAllSetor(page, {
        descricao: search
      })
    },
    loadPorte(page, search) {
      return findAllPorte(page, {
        descricao: search
      })
    },
    loadRamoAtuacao(page, search) {
      return findAllRamoAtuacao(page, {
        descricao: search
      })
    },
    async verDetalhe(objeto) {
      try {
        this.loading = true;
        const fornecedor = await findOneFornecedor(objeto.id);
        this.item = fornecedor.dados[0];
        this.detalheDialogOpened = true;
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          });
        } else {           
          this.$toast.error(`Não foi possível recuperar os dados do Fornecedor. Tente Novamente mais tarde. ${err}`, {
            timeout: 6000
          });
        }
      } finally {
        this.loading = false;
      }
    }, 

    async refresh() {
      const self = this;

      this.totalFornecedorPorSetor.isLoading = true;
      findGraficoFornecedor(1, {
        tipoSaida: 'setor',
        cnpj: this.localSearch.cnpjAux.chave,
        cidade: this.localSearch.cidadeAux.chave,
        estado: this.localSearch.estadoAux,
        idSetor: this.localSearch.setor.id,
        idPorte: this.localSearch.porte.id,
        idRamoAtuacao: this.localSearch.ramoAtuacao.id,
      }).then(page => {
        this.totalFornecedorPorSetor.series = page.elements.map(item => item.quantidade || 0);
        this.totalFornecedorPorSetor.chartOptions.labels = page.elements.map(item => item.descricao || '');
        // Adiciona o evento de clique
        this.totalFornecedorPorSetor.chartOptions.chart.events = {
          dataPointSelection: function(event, chartContext, config) {
            const setor = config.w.config.labels[config.dataPointIndex];
            if (self && typeof self.$refs.comboSetor.search === 'function') {
              self.$refs.comboSetor.searchInput = setor;
              self.$refs.comboSetor.search();
            }
          }
        };      
        this.$refs.totalFornecedorPorSetor.updateOptions({
          ...this.totalFornecedorPorSetor.chartOptions,
          series: this.totalFornecedorPorSetor.series,
        }, true);
      }).catch(err => {
        console.log("Erro ao carregar gráfico: " + this.totalFornecedorPorSetor.tituloGrafico + ". " + err.message);
      }).finally(() => {
        this.totalFornecedorPorSetor.isLoading = false;
      });

      this.totalFornecedorPorPorte.isLoading = true;
      findGraficoFornecedor(1, {
        tipoSaida: 'porte',
        cnpj: this.localSearch.cnpjAux.chave,
        cidade: this.localSearch.cidadeAux.chave,
        estado: this.localSearch.estadoAux,
        idSetor: this.localSearch.setor.id,
        idPorte: this.localSearch.porte.id,
        idRamoAtuacao: this.localSearch.ramoAtuacao.id,
      }).then(page => {
        this.totalFornecedorPorPorte.series = page.elements.map(item => item.quantidade || 0);
        this.totalFornecedorPorPorte.chartOptions.labels = page.elements.map(item => item.descricao || '');
        // Adiciona o evento de clique
        this.totalFornecedorPorPorte.chartOptions.chart.events = {
          dataPointSelection: function(event, chartContext, config) {
            const porte = config.w.config.labels[config.dataPointIndex];
            if (self && typeof self.$refs.comboPorte.search === 'function') {
              self.$refs.comboPorte.searchInput = porte;
              self.$refs.comboPorte.search();
            }
          }
        };          
        this.$refs.totalFornecedorPorPorte.updateOptions({
          ...this.totalFornecedorPorPorte.chartOptions,
          series: this.totalFornecedorPorPorte.series,
        }, true);
      }).catch(err => {
        console.log("Erro ao carregar gráfico: " + this.totalFornecedorPorPorte.tituloGrafico + ". " + err.message);
      }).finally(() => {
        this.totalFornecedorPorPorte.isLoading = false;
      });

      this.totalFornecedorPorRamoAtuacao.isLoading = true;
      findGraficoFornecedor(1, {
        tipoSaida: 'ramoAtuacao',
        cnpj: this.localSearch.cnpjAux.chave,
        cidade: this.localSearch.cidadeAux.chave,
        estado: this.localSearch.estadoAux,
        idSetor: this.localSearch.setor.id,
        idPorte: this.localSearch.porte.id,
        idRamoAtuacao: this.localSearch.ramoAtuacao.id,
      }).then(page => {
        this.totalFornecedorPorRamoAtuacao.series = page.elements.map(item => item.quantidade || 0);
        this.totalFornecedorPorRamoAtuacao.chartOptions.labels = page.elements.map(item => item.descricao || '');
        // Adiciona o evento de clique
        this.totalFornecedorPorRamoAtuacao.chartOptions.chart.events = {
          dataPointSelection: function(event, chartContext, config) {
            const ramoAtuacao = config.w.config.labels[config.dataPointIndex];
            if (self && typeof self.$refs.comboRamoAtuacao.search === 'function') {
              self.$refs.comboRamoAtuacao.searchInput = ramoAtuacao;
              self.$refs.comboRamoAtuacao.search();
            }
          }
        };          
        this.$refs.totalFornecedorPorRamoAtuacao.updateOptions({
          ...this.totalFornecedorPorRamoAtuacao.chartOptions,
          series: this.totalFornecedorPorRamoAtuacao.series,
        }, true);
      }).catch(err => {
        console.log("Erro ao carregar gráfico: " + this.totalFornecedorPorRamoAtuacao.tituloGrafico + ". " + err.message);
      }).finally(() => {
        this.totalFornecedorPorRamoAtuacao.isLoading = false;
      });
      
      this.totalFornecedorPorEstado.isLoading = true;
      findGraficoFornecedor(1, {
        tipoSaida: 'estado',
        cnpj: this.localSearch.cnpjAux.chave,
        cidade: this.localSearch.cidadeAux.chave,
        estado: this.localSearch.estadoAux,
        idSetor: this.localSearch.setor.id,
        idPorte: this.localSearch.porte.id,
        idRamoAtuacao: this.localSearch.ramoAtuacao.id,
      }).then(page => {
        this.totalFornecedorPorEstado.series = [{
          name: 'Fornecedores',
          data: page.elements.map(item => item.quantidade || 0)
        }];
        this.totalFornecedorPorEstado.chartOptions.xaxis.categories = page.elements.map(item => item.descricao || '');
        // Adiciona o evento de clique
        this.totalFornecedorPorEstado.chartOptions.chart.events = {
          dataPointSelection: function(event, chartContext, config) {
            const estado = config.w.config.xaxis.categories[config.dataPointIndex];
            if (self) {
              self.localSearch.estadoAux = estado;
            }
          }
        };
        this.$refs.totalFornecedorPorEstado.updateOptions({
          ...this.totalFornecedorPorEstado.chartOptions,
          series: this.totalFornecedorPorEstado.series,
        }, true);
      }).catch(err => {
        console.log("Erro ao carregar gráfico: " + this.totalFornecedorPorEstado.tituloGrafico + ". " + err.message);
      }).finally(() => {
        this.totalFornecedorPorEstado.isLoading = false;
      });
      
      this.totalFornecedorPorCidade.isLoading = true;
      findGraficoFornecedor(1, {
        tipoSaida: 'cidade',
        cnpj: this.localSearch.cnpjAux.chave,
        cidade: this.localSearch.cidadeAux.chave,
        estado: this.localSearch.estadoAux,
        idSetor: this.localSearch.setor.id,
        idPorte: this.localSearch.porte.id,
        idRamoAtuacao: this.localSearch.ramoAtuacao.id,
      }).then(page => {
        this.totalFornecedorPorCidade.series = [{
          name: 'Fornecedores',
          data: page.elements.map(item => item.quantidade || 0)
        }];
        this.totalFornecedorPorCidade.chartOptions.dataLabels.enabled = page.elements.length <= 20;
        this.totalFornecedorPorCidade.chartOptions.xaxis.categories = page.elements.map(item => item.descricao || '');
        // Adiciona o evento de clique
        this.totalFornecedorPorCidade.chartOptions.chart.events = {
          dataPointSelection: function(event, chartContext, config) {
            const cidade = config.w.config.xaxis.categories[config.dataPointIndex];
            if (self) {
              self.localSearch.cidadeAux.chave = cidade;
              self.localSearch.cidadeAux.valor = cidade;
            }
          }
        };
        this.$refs.totalFornecedorPorCidade.updateOptions({
          ...this.totalFornecedorPorCidade.chartOptions,
          series: this.totalFornecedorPorCidade.series,
        }, true);
      }).catch(err => {
        console.log("Erro ao carregar gráfico: " + this.totalFornecedorPorCidade.tituloGrafico + ". " + err.message);
      }).finally(() => {
        this.totalFornecedorPorCidade.isLoading = false;
      });
    },
    clearFilters() {
      this.localSearch = {
        cnpjAux: { chave: null, valor: null },
        estadoAux: null,
        cidadeAux: { chave: null, valor: null },
        setor: { id: null, descricao: null },
        porte: { id: null, descricao: null },
        ramoAtuacao: { id: null, descricao: null },
      };
      // Limpa os campos dos componentes SearchBox
      if (this.$refs.comboCidades) this.$refs.comboCidades.resetValues();
      if (this.$refs.comboSetor) this.$refs.comboSetor.resetValues();
      if (this.$refs.comboPorte) this.$refs.comboPorte.resetValues();
      if (this.$refs.comboRamoAtuacao) this.$refs.comboRamoAtuacao.resetValues();
      this.refresh();
    }
  },
  mounted() {
    this.refresh();
  },
}
</script>
<style scoped lang="scss">
.page .is-mobile {
  .content {
    overflow: auto;
    max-height: calc(100vh - 60px);
  }

  ::v-deep {
    .v-data-table__wrapper {
      height: calc(100vh - 97px);
    }
  }
}

.page .content {
  /*border:2px solid green;*/
  overflow: auto;
  max-height: calc(100vh - 50px);
  width: 100%;
  flex: 1;

  ::v-deep {
    .v-data-table__wrapper {
      height: calc(100vh - 157px);
    }
  }
}
.rounded-border {
  border-radius: 8px !important;
  border: 0px !important;
}
.titulo {
  font-size: 1em;
  font-weight: bold;
  color:#167ABC;
}
.sub-titulo {
  font-size: 0.8em;
}
.titulo-grafico {
  font-size: 1em;
  font-weight: bold;
  color:black;
}
.chart-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%; /* Ajuste conforme necessário */
}
</style>